export default class OtherPortfolioCtrl {
  constructor ($scope, $stateParams, $timeout, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, ngYoutubeEmbedService) {
  // constants
    var otherPortfolioVm = this

    otherPortfolioVm.userId = JSON.parse($cookies.get('currentUser')).id
    const guestPortfolio = {
      userId : otherPortfolioVm.userId
    }

    otherPortfolioVm.users = []

    otherPortfolioVm.visitPortfolio = visitPortfolio

    activate()

    function activate () {
      getSharedPortfolio()
    }

    function getSharedPortfolio(){
    	PortfolioSrv.getSharedPortfolio.get(guestPortfolio).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        otherPortfolioVm.users = dataReturn.data
	      }
		  }, function (data) {
		      console.log(data)
		    }
	    )
    }

    function visitPortfolio(user){
      $cookies.put('ownerPortfolio', user.idOwner)
      $state.go('portfolio.visitPortfolio')
    }
    

  }
}

OtherPortfolioCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'PortfolioSrv', 'PortfolioModalSrv','GlobalConfig', '$cookies', '$state']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/otherPortfolio/otherPortfolioCtrl.js